export const Logo = ({ className = "h-11" }) => (
    <img
        src="/logo-mark.png"
        alt="Brandão Morais Higienização"
        className={`${className} w-auto transition-transform duration-300 group-hover:scale-105`}
    />
);
